<template>
    <div class="container-rt">       
        <div v-if="mostraSke">
          
            <div v-if="erro" style="text-align:center;margin:30px 0px;">  
                <span v-if="rotaA != 'GeralRRF_EMD'" >
                    <p v-if="isRota == 'GeralCSRF_EMD'">
                        Aplica-se apenas aos órgãos da administração direta, autarquias, e fundações da administração pública do Distrito Federal, dos Estados e dos Municípios, que firmarem convênios com a RFB.
                    </p>
                    <p v-if="isRota == 'GeralCSRF_EMD'">
                        Não alcançam os pagamentos efetuados por empresas públicas e sociedades de economia mista do Distrito Federal, dos Estados e dos Municípios, as quais se sujeitam ao disposto no art. 30 da Lei nº 10.833, de 29 de dezembro de 2003. (Regra geral, vide retenções conforme código em CSRF Contribuições Sociais) (IN SRF nº 475/2004, art. 1, §3º)
                    </p>
                    <p style="text-align: center !important;">Não há previsão legal para retenção.</p>
                    
                </span>              
               <hr v-if="rotaA != 'GeralRRF_EMD'">
            </div>           
            <div v-else>
                
                <div class="dados"  v-if="!!aliquota || !!codDarf || !!aliquota || !!vencimento || !!geralAliquotas">
                    <p v-if="isRota == 'GeralCSRF_EMD'">
                        Aplica-se apenas aos órgãos da administração direta, autarquias, e fundações da administração pública do Distrito Federal, dos Estados e dos Municípios, que firmarem convênios com a RFB.
                    </p>
                    <p v-if="isRota == 'GeralCSRF_EMD'">
                        Não alcançam os pagamentos efetuados por empresas públicas e sociedades de economia mista do Distrito Federal, dos Estados e dos Municípios, as quais se sujeitam ao disposto no art. 30 da Lei nº 10.833, de 29 de dezembro de 2003. (Regra geral, vide retenções conforme código em CSRF Contribuições Sociais) (IN SRF nº 475/2004, art. 1, §3º)
                    </p>
                    <p txtGEral v-if="!!aliquota || !!codDarf || !!aliquota || !!complemento || !!geralAliquotas"><img src="/sandboxfront/rtfonte/engrenagem.svg" alt=""> Dados gerais e alíquotas</p>
                    <div v-html="geralAliquotas">

                    </div>
                    <p v-if="aliquota2" style="margin-bottom: 0px;margin-top: 10px;">a)</p>             
                    <div class="info" v-if="!!aliquota"><span >Alíquota: </span><span v-html="aliquota"></span></div>
                    <div class="info" v-if="!!codDarf"><span>Código DARF: </span><span v-html="codDarf"></span></div>
                     <div class="info" v-if="!!codGPS"><span>Código GPS: </span><span v-html="codGPS"></span></div>
                     <div class="info" v-if="!!redacao"><span>Redação na Instrução Normativa 971/09: </span><span v-html="redacao"></span></div>
                    <div class="info" v-if="!!fundLegal"><span>Fundamentação Legal:</span><span v-html="fundLegal"></span></div>
                    <p v-if="aliquota2" style="margin-bottom: 0px;margin-top: 10px;">b)</p>
                    <div v-if="aliquota2">
                        <div class="info" v-if="!!aliquota2"><span >Alíquota: </span><span v-html="aliquota2"></span></div>
                        <div class="info" v-if="!!darf2"><span>Código DARF: </span><span v-html="darf2"></span></div>
                        <div class="info" v-if="!!fundLegal2"><span>Fundamentação Legal:</span><span v-html="fundLegal2"></span></div>
                    </div>
                    <p txtGEral v-if="!!vencimento"><img src="/sandboxfront/rtfonte/calendario.svg" alt=""> Vencimentos</p>
                    <div class="info" v-if="!!vencimento"><span>Vencimento: </span><span v-html="vencimento"></span></div>
                </div>
                <hr v-if="!!aliquota ||!!codDarf || !!aliquota || !!vencimento || !!complemento">
                <div class="dados" v-if="!!texto || !!complemento">
                     <p txtGEral> <img src="/sandboxfront/rtfonte/file.svg" alt=""> Dados complementares</p>
                     <div v-html="texto">
                     </div>   
                     <div v-html="complemento">
                     </div>                  
                </div>                
                <hr v-if="!!complemento || !!texto">             
               
               
            </div>           
            
        </div>
        <div v-else>
            <span class="skeleton-loaderOutrasPagMenor"></span> 
            <span class="skeleton-loaderOutrasPagMenor"></span> 
            <span class="skeleton-loaderOutrasPagMenor"></span> 
            <span class="skeleton-loaderOutrasPagMaior"></span> 
            <hr>
            <span class="skeleton-loaderOutrasPagMenor"></span> 
            <span class="skeleton-loaderOutrasPagMaior"></span> 
            <span class="skeleton-loaderOutrasPagMaior"></span> 
        </div>
    </div>
</template>

<script>
import {link,token} from '../services/link.js'
import axios from 'axios'
export default {
    props:['isRota'],
    data(){
        return{
            mostraSke:false,
            dados:[],
            erro:false,
            aliquota:'',
            codDarf:'',
            fundLegal:'',
            vencimento:'',
            texto:'',
            geralAliquotas:'',
            complemento:'',
            primeiro:'GeralIRRF',
            rotaA:'',
            aliquota2:'',
            darf2:'',
            fundLegal2:'',
            codGPS:'',
            redacao:''

        }
    },
    methods:{
        async regra(){
            
            if(this.$store.state.id == "4.02" || this.$store.state.id == "4.03" || this.$store.state.id == '4.08' || this.$store.state.id == '4.09' || this.$store.state.id == '4.21' || this.$store.state.id == '4.22' || this.$store.state.id == '4.23'){
                await axios.get(`${link}/GeralCOSIRFExtra/${this.$store.state.idItem}/${token}`)
                .then(e=>{
                    let dado = e.data[0]
                    console.log(dado)
                    this.aliquota2 = dado?.aliquota
                    this.darf2 = dado?.darf
                    this.fundLegal2 = dado?.fundamentacao                  
                })
            }
        },
        async chamaFn(rota){
            this.rotaA = rota
            this.dados = []
            this.mostraSke = false
            this.aliquota2 = ''
            this.darf2 = ''
            this.fundLegal2 = ''
            await axios.get(`${link}/${rota}/${this.$store.state.idItem}/${token}`)
            .then(e=>{console.log(e.data)
                this.dados = e.data
                this.aliquota = this.dados[0]?.aliquota
                this.codDarf = this.dados[0]?.darf
                this.codGPS = this.dados[0]?.gps
                this.redacao = this.dados[0]?.redacao_IN
                this.fundLegal = this.dados[0]?.fundamentacao
                this.geralAliquotas = this.dados[0]?.geral_aliquotas
                console.log(this.geralAliquotas)
                this.complemento = this.dados[0]?.complemento
                this.vencimento = this.dados[0]?.vencimento
                this.texto = this.dados[0]?.texto
                this.erro  = this.dados.length >=1 ? false : true
            }).catch(a=>{
                console.log(a)
                this.erro = true
            })
            if(this.rotaA == 'GeralCOSIRF'){
                console.log('vindo')
                await this.regra()
            }            
            this.mostraSke = true
            this.$emit('fn',this.chamaFn)
        }
    },
    async mounted(){
        window.scroll(0,0)
        this.chamaFn(this.primeiro)
    },

}
</script>

<style>
[txtGEral]{
    font-size:20px;
    font-weight: bold;
    margin-bottom: 0px;
    margin-top:20px;
    display: flex;
    align-items: center;
}
[txtGEral] img{
    margin-right: 5px;
}
.container-rt{
    color:#707070;
}
.info span:nth-child(1){
    font-weight: bold;
}
</style>